module.exports = __webpack_public_path__ + "media/images/goals-2 2-eda082e27522e9456677195255cf2873.jpg";